export const ROUTE_FILTER_ALL = 'ALL';

// Mirrors the label convention in routes/RouteListItem.js and map/AssignToRoute.js.
// Shell routes carry route_number: Infinity, so the isFinite check matters.
export const getRouteLabel = (route) => {
    if (route?.route_alias) return route.route_alias;
    return isFinite(route?.route_number) ? `Route ${route.route_number}` : '--';
};

// A route holds an order when it has at least one mapping that isn't a discarded
// duplicate — same guard as routeShippers.js.
const hasLiveOrders = (route) => (route?.orders || []).some((m) => m?.order_id && m.duplicate_override !== 'DUPLICATE');

// Routes that actually hold orders, sorted like the query's route_number asc.
// Excludes the client-minted shell routes, which have no orders.
export const getRouteFilterOptions = (routes = []) => {
    const byValue = new Map();

    for (const route of routes) {
        if (!route?.route_id || byValue.has(route.route_id)) continue;
        if (!hasLiveOrders(route)) continue;
        byValue.set(route.route_id, {
            value: route.route_id,
            label: getRouteLabel(route),
            sortKey: isFinite(route.route_number) ? route.route_number : Infinity,
        });
    }

    return [...byValue.values()]
        .sort((a, b) => a.sortKey - b.sortKey || String(a.label).localeCompare(String(b.label)))
        .map(({ value, label }) => ({ value, label }));
};

// Leg-aware membership test. Reads the route ids planningDerivations injects on
// rows, not order.routes[] — those mappings carry no leg semantics.
export const orderMatchesRoute = (order, routeId) => {
    if (!routeId) return false;
    const rowRouteId = order?.crossdock_leg === 'pickup' ? order?.pickup_route_id : order?.dropoff_route_id;
    return rowRouteId === routeId;
};
